const general_event = require("../config/general_event");
const { recursiveAsyncReadLine } = require("../action/common");
const on = (topic, callback, config) => {
  switch (topic) {
    case "disk_monitor":
      const { disk_monitor_start } = require("./linux_common/disk_monitor");
      disk_monitor_start(config?.disk_monitor_interval);
      break;
    case "diskIO_monitor":
      const { diskIO_monitor_start } = require("./linux_common/diskIO_monitor");
      diskIO_monitor_start(config?.diskIO_monitor_interval);
      break;
    case "cpu_monitor":
      const { cpu_monitor_start } = require("./linux_common/cpu_monitor");
      cpu_monitor_start(config?.cpu_monitor_interval);
      break;
    case "ram_monitor":
      const { ram_monitor_start } = require("./linux_common/ram_monitor");
      ram_monitor_start(config?.ram_monitor_interval);
      break;
  }
  general_event.on(topic, callback);
}

const off = (topic, callback) => {
  general_event.off(topic, callback);
  if (general_event.listenerCount(topic) === 0) {
    console.log(`${topic} off`);
    switch (topic) {
      case "disk_monitor":
        const { disk_monitor_stop } = require("./linux_common/disk_monitor");
        disk_monitor_stop();
        break;
      case "diskIO_monitor":
        const { diskIO_monitor_stop } = require("./linux_common/diskIO_monitor");
        diskIO_monitor_stop();
        break;
      case "cpu_monitor":
        const { cpu_monitor_stop } = require("./linux_common/cpu_monitor");
        cpu_monitor_stop();
        break;
      case "ram_monitor":
        const { ram_monitor_stop } = require("./linux_common/ram_monitor");
        ram_monitor_stop();
        break;
    }
  }
}

  if (require.main === module) {
    const help_message = `
  1. disk_monitor on
  2. disk_monitor off
  3. diskIO_monitor on
  4. diskIO_monitor off
  5. cpu_monitor on
  6. cpu_monitor off
  7. ram_monitor on
  8. ram_monitor off
  `
    console.log(help_message);
    const disk_monitor_callback = (disk_info) => {
      console.log(disk_info);
    }
    const diskIO_monitor_callback = (disk_info) => {
      console.log(disk_info);
    }
    const cpu_monitor_callback = (cpu_info) => {
      console.log(cpu_info);
    }
    const ram_monitor_callback = (ram_info) => {
      console.log(ram_info);
    }
    recursiveAsyncReadLine(async (input) => {
      switch (input) {
        case "1":
          on("disk_monitor", disk_monitor_callback);
          break;
        case "2":
          off("disk_monitor", disk_monitor_callback);
          break;
        case "3":
          on("diskIO_monitor", diskIO_monitor_callback);
          break;
        case "4":
          off("diskIO_monitor", diskIO_monitor_callback);
          break;
        case "5":
          on("cpu_monitor", cpu_monitor_callback);
          break;
        case "6":
          off("cpu_monitor", cpu_monitor_callback);
          break;
        case "7":
          on("ram_monitor", ram_monitor_callback);
          break;
        case "8":
          off("ram_monitor", ram_monitor_callback);
          break;
        default:
          console.log(help_message);
          break;
      }
    });
  }

  module.exports = {
    on,
    off
  }